import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { BotsCreators } from '../../../store/actions/bots';
import { resetFlowPath } from '../../../store/actions/bot-creator';

import InputDropdown from '../../../bergmannsoft/components/Widgets/Forms/InputDropdown';
import ConfirmVersionDialog from './ConfirmVersionDialog';

const Versions = ({ bot }) => {
  const userClaim = useSelector(
    (state) => state.users?.signedUser?.selectedCompany?.claim?.name
  );

  const [chosenVersion, setChosenVersion] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [viewer, setViewer] = useState(false);

  useEffect(() => {
    if (userClaim && userClaim === 'Viewer') {
      setViewer(true);
    }
  }, []);

  const dispatch = useDispatch();

  if (!bot && Object.keys(bot).length === 0) {
    return false;
  }

  const formattedVersions = bot?.versions?.map((version) => {
    const formattedDate = moment(version.createDate).format(
      'DD/MM/YYYY - HH:mm'
    );
    return { ...version, name: formattedDate };
  });

  if (formattedVersions?.length === 0) {
    return '';
  }

  const handleChangeVersion = (version) => {
    if (!viewer) {
      setChosenVersion(version);
      setModalIsOpen(true);
    }
  };

  const handleCloseConfirmModal = () => {
    setModalIsOpen(false);
    setChosenVersion({});
  };

  const handleConfirmChangeVersion = () => {
    if (!viewer) {
      dispatch(resetFlowPath(true));
      dispatch(BotsCreators.changeStagingArea(bot._id, chosenVersion));
      setModalIsOpen(false);
    }
  };

  return (
    <>
      <InputDropdown
        className="dropdown-header-versions"
        value="Versões Anteriores"
        dropdownItemsList={formattedVersions}
        onChange={(value) => handleChangeVersion(value)}
        styleWidth="9.5rem"
        darkMode
        frozenValue
      />

      {modalIsOpen && (
        <ConfirmVersionDialog
          isOpen={modalIsOpen}
          onClose={() => handleCloseConfirmModal()}
          onSubmit={() => handleConfirmChangeVersion()}
        />
      )}
    </>
  );
};

export default Versions;
